import { forwardRef } from 'react';

// https://www.totaltypescript.com/forwardref-with-generic-components
export function genericForwardRef<T, P = object>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode,
): (props: P & React.RefAttributes<T>) => React.JSX.Element {
  return forwardRef(render as any) as any;
}
